import ScreenHeader from '@/components/ScreenHeader/ScreenHeader.vue';
import FormInput from '@/components/FormInput/FormInput.vue';
import DetailTable from '@/components/DetailTable/DetailTable.vue';
import SaveButtonArea from '@/components/SaveButtonArea/SaveButtonArea.vue';
import NotificationModal from '@/components/NotificationModal/NotificationModal.vue';

import EstimateParticularService from '@/services/API/estimate_particular.service';
import InvoiceService from '@/services/API/invoice.service';

import { mapState } from 'vuex';
import autoBankMixin from '@/mixin/autoBankMixin';

const SUB_TOTAL_INDEX = 0;
const TOTAL_TAX_INDEX = 1;
const HOLDING_TAX_INDEX = 2;
const TOTAL_INDEX = 3;

export default {
	components: {
		ScreenHeader,
		FormInput,
		DetailTable,
		SaveButtonArea,
		NotificationModal,
	},
	mixins: [autoBankMixin],
	props: {
		/**
		 * @binding estimate Props Data
		 * @value estimateParticular {object}: estimate particular data
		 * @value estimateDetails {array}: array of estimate detail objects
		 */
		estimatePropData: {
			type: Object,
		},
		propUserId: {
			type: Number,
		},
		projectId: {
			type: Number,
		},
		invoiceData: {
			type: Object,
		},
		bankInfo: {
			type: Object,
		},
	},
	data() {
		return {
			middleContent: ' 様 ／ ',
			screenIcon: 'addcost-icon',
			screenName: '請求書作成',
			projectDeadline: '2021 年 9 月 25日',
			formInputs: [
				{
					inputLabel: '請求先',
					type: 'text',
					hiddenInput: true,
					toggleBorder: true,
					keyLabel: '',
				},
				{
					inputLabel: this.$t(
						'creatorApp.estimateScreen.quotationScreen.issueDate.label'
					),
					noteLabel: this.$t(
						'creatorApp.estimateScreen.quotationScreen.issueDate.note-label'
					),
					keyLabel: 'issue_date',
					type: 'date',
					toggleStyle: true,
					inputPropContent: '',
				},
				{
					inputLabel: '振込期限',
					noteLabel: this.$t(
						'creatorApp.estimateScreen.quotationScreen.issueDate.note-label'
					),
					keyLabel: 'expiry_date',
					type: 'date',
					toggleStyle: true,
					inputPropContent: '',
					modalCustom: true,
				},
				{
					inputLabel: this.$t(
						'creatorApp.estimateScreen.quotationScreen.supplier.label'
					),
					placeholder: this.$t(
						'creatorApp.estimateScreen.quotationScreen.supplier.placeholder'
					),
					keyLabel: 'supplier_name',
					type: 'text',
					inputPropContent: '',
					disabled: true,
				},
				{
					inputLabel: this.$t(
						'creatorApp.estimateScreen.quotationScreen.projectTitle.label'
					),
					placeholder: this.$t(
						'creatorApp.estimateScreen.quotationScreen.projectTitle.placeholder'
					),
					keyLabel: 'project_name',
					type: 'text',
					inputPropContent: '',
					disabled: true,
				},
				{
					inputLabel: '請求元',
					keyLabel: '',
					type: 'text',
					hiddenInput: true,
					toggleBorder: true,
				},
				{
					inputLabel: this.$t(
						'creatorApp.estimateScreen.quotationScreen.companyName.label'
					),
					placeholder: this.$t(
						'creatorApp.estimateScreen.quotationScreen.companyName.placeholder'
					),
					keyLabel: 'company_name',
					type: 'text',
					inputPropContent: '',
					disabled: true,
				},
				{
					inputLabel: this.$t(
						'creatorApp.estimateScreen.quotationScreen.fullName.label'
					),
					placeholder: this.$t(
						'creatorApp.estimateScreen.quotationScreen.fullName.placeholder'
					),
					keyLabel: 'estimator_name',
					type: 'text',
					inputPropContent: '',
					disabled: true,
				},
				{
					inputLabel: this.$t(
						'creatorApp.estimateScreen.quotationScreen.postalCode.label'
					),
					noteLabel: '',
					keyLabel: 'postal_code',
					placeholder: this.$t(
						'creatorApp.estimateScreen.quotationScreen.postalCode.placeholder'
					),
					type: 'text',
					inputPropContent: '',
					disabled: true,
				},
				{
					inputLabel: this.$t(
						'creatorApp.estimateScreen.quotationScreen.address.label'
					),
					placeholder: this.$t(
						'creatorApp.estimateScreen.quotationScreen.address.placeholder'
					),
					keyLabel: 'address',
					type: 'text',
					inputPropContent: '',
					disabled: true,
				},
				{
					inputLabel: this.$t(
						'creatorApp.estimateScreen.quotationScreen.phoneNumber.label'
					),
					keyLabel: 'phone_number',
					placeholder: this.$t(
						'creatorApp.estimateScreen.quotationScreen.phoneNumber.placeholder'
					),
					type: 'number',
					inputPropContent: '',
					disabled: true,
				},
				{
					inputLabel: '口座情報',
					keyLabel: '',
					type: 'text',
					hiddenInput: true,
					toggleBorder: true,
				},
				{
					inputLabel: '銀行名',
					keyLabel: 'bank_name',
					placeholder: '銀行名',
					caption: '銀行',
					type: 'text',
					inputPropContent: '',
					disabled: false,
					isShowBadge: true,
					inputRequired: true,
				},
				{
					inputLabel: '支店名',
					keyLabel: 'bank_branch',
					placeholder: '支店名',
					caption: '支店',
					type: 'text',
					inputPropContent: '',
					disabled: false,
					isShowBadge: true,
					inputRequired: true,
				},
				{
					inputLabel: '口座種別',
					keyLabel: 'account_type',
					placeholder: this.$t(
						'creatorApp.estimateScreen.quotationScreen.phoneNumber.placeholder'
					),
					type: 'radio',
					checkBoxOptions: ['普通', '当座'],
					inputPropContent: '普通',
					disabled: false,
					isShowBadge: true,
					inputRequired: true,
				},
				{
					inputLabel: '口座名義人',
					keyLabel: 'account_holder',
					placeholder: '口座名義人',
					type: 'text',
					inputPropContent: '',
					disabled: false,
					isShowBadge: true,
					inputRequired: true,
				},
				{
					inputLabel: '口座番号',
					keyLabel: 'account_number',
					placeholder: '口座番号',
					type: 'number',
					inputPropContent: '',
					disabled: false,
					isShowBadge: true,
					inputRequired: true,
				},
				{
					inputLabel: this.$t('creatorApp.estimateScreen.quotationScreen.detail.label'),
					type: '',
					hiddenInput: true,
					keyLabel: '',
					disabled: true,
				},
			],
			billCosts: [
				{
					label: this.$t('creatorApp.estimateScreen.quotationScreen.subTotal.label'),
					keyLabel: this.$t(
						'creatorApp.estimateScreen.quotationScreen.subTotal.key-label'
					),
					moneyAmount: '0,000',
					moneyUnit: this.$t('creatorApp.estimateScreen.quotationScreen.moneyUnit'),
				},
				{
					label: this.$t('creatorApp.estimateScreen.quotationScreen.tax.label'),
					keyLabel: this.$t('creatorApp.estimateScreen.quotationScreen.tax.key-label'),
					moneyAmount: '0,000',
					moneyUnit: this.$t('creatorApp.estimateScreen.quotationScreen.moneyUnit'),
				},
				{
					label: this.$t('creatorApp.estimateScreen.quotationScreen.holding_tax.label'),
					moneyAmount: '0,000',
					moneyUnit: this.$t('creatorApp.estimateScreen.quotationScreen.moneyUnit'),
				},
				{
					label: this.$t('creatorApp.estimateScreen.quotationScreen.total.label'),
					keyLabel: this.$t(
						'creatorApp.estimateScreen.quotationScreen.total.key-label'
					),
					moneyAmount: '0,000',
					moneyUnit: this.$t('creatorApp.estimateScreen.quotationScreen.moneyUnit'),
				},
			],
			// 詳細データ
			infoFormInput: {
				bank_name: '',
				bank_branch: '',
				account_type: '普通',
			},
			// 明細データ
			estimateDetails: [],
			originEstimateDetails: [],
			comparesionEstimateDetails: [],
			// 明細データからトータルになる金額のデータ
			estimateParticular: {},
			estimateParticularId: undefined,
			infoBillCosts: {},
			remarkContent: '',
			deletedItems: [],
			canSaveQuotationContents: false,
			formInputValid: false,
			detailTableValid: true,
		};
	},
	computed: {
		// Get userId from store
		...mapState(['userId', 'projectInfo', 'clientInfo']),
	},
	watch: {
		/**
		 * Watch prop estimatePropData change
		 * @param {object} estimatePropData
		 */
		estimatePropData: {
			handler: function (estimatePropData) {
				let originEstimateDetails = [...estimatePropData.estimateDetails];
				for (let i = 0; i < originEstimateDetails.length; i++) {
					originEstimateDetails[i]['disabled'] = true;
				}

				this.originEstimateDetails = [...originEstimateDetails];
				this.comparesionEstimateDetails = [...estimatePropData.estimateDetails];

				this.estimateParticular = {
					...estimatePropData.estimateParticular,
				};
				this.remarkContent = estimatePropData.estimateParticular['comment'];

				if (estimatePropData.estimateParticular['id']) {
					this.estimateParticularId = estimatePropData.estimateParticular['id'];
				}

				this.billCosts[SUB_TOTAL_INDEX].moneyAmount =
					estimatePropData.estimateParticular['subtotal'];
				this.billCosts[TOTAL_TAX_INDEX].moneyAmount =
					estimatePropData.estimateParticular['consumption_tax'];
				this.billCosts[HOLDING_TAX_INDEX].moneyAmount =
					estimatePropData.estimateParticular['holding_tax'];
				this.billCosts[TOTAL_INDEX].moneyAmount =
					estimatePropData.estimateParticular['total'];
			},
			deep: true,
		},

		/**
		 * Watch estimateParticular
		 * get inputPropContent properly of formInputs
		 * @param {object} estimateParticular
		 */
		estimateParticular: {
			handler: function (estimateParticular) {
				this.formInputs.map((item) => {
					item.inputPropContent = estimateParticular[`${item.keyLabel}`];
				});
			},
			deep: true,
		},
	},
	methods: {
		onClickInput() {},

		getFormInputData(transferredObject) {
			console.log({ transferredObject });
			this.infoFormInput[transferredObject.key] = transferredObject.val;
			if (
				!this.infoFormInput.issue_date ||
				!this.infoFormInput.expiry_date ||
				!this.infoFormInput.bank_name ||
				!this.infoFormInput.bank_branch ||
				!this.infoFormInput.account_holder ||
				!this.infoFormInput.account_number ||
				!this.infoFormInput.account_type
			) {
				this.formInputValid = false;
			} else {
				this.formInputValid = true;
			}
			this.formInputs.map((item) => {
				if (item.keyLabel === transferredObject.key) {
					if (!transferredObject.val) {
						item.isShowBadge = true;
					} else {
						item.isShowBadge = false;
					}
				}
			});
		},

		isSaveButtonDisable() {
			if (this.formInputValid) {
				return false; // If all required input is filled, return false to enable Save Button
			} else {
				return true; // If all required input is not fill yet, return true to disable Save Button
			}
		},

		async onSaveButtonClick() {
			this.$store.commit('setIsAppProcessing', true);

			// Get remark content data
			let remarkContent = {
				comment: this.remarkContent,
			};
			let userId = {
				update_user: this.userId,
			};

			// Merge data from intoFormInput, infoBillCost and remarkContent into estimateParticular
			let estimateParticular = {
				...this.infoFormInput,
				...remarkContent,
				...userId,
			};

			this.estimateParticular = estimateParticular;
			await this._saveInvoiceData();

			//Check if quotation have been created or not
			if (this.canSaveQuotationContents) {
				let sendData = {
					isShowQuotation: true,
				};
				this.$emit('on-save-btn-click', sendData);
			} else {
				// Remove error modal temporary
				console.log('%c Save quotation failed!', 'color: red');
			}
		},

		async _saveInvoiceData() {
			try {
				if (!this.invoiceData.id) {
					this._createNewInvoice(this.estimateParticular);
					this.$emit('on-change-settlement-status', 'onSave');
				} else {
					this._updateInvoice(this.estimateParticular);
				}

				//estimateParticularId is existed
				//Check create, update, delete estimate detail here
				if (this.estimateDetails.length > 0) {
					this.isEstimateDetailsCreated = true;
					// Update EstimateParticular after because subtotal, total, and tax change
					await this._updateEstimateParticular(
						this.estimateParticularId,
						this.estimateParticular
					);
				}
				this.canSaveQuotationContents = true;
			} catch (error) {
				this.canSaveQuotationContents = false;
			}
		},

		async _updateEstimateParticular(estimateParticularId, estimateParticular) {
			let body = { ...estimateParticular };
			body['update_user'] = this.userId;

			delete body['project_name'];
			delete body['issue_date'];
			delete body['expiry_date'];

			let response = await EstimateParticularService.update(estimateParticularId, {
				doc_content: body,
			});
			if (response && response.status === 200) {
				console.log('Update Estimate particular successfully!');
			} else {
				throw response.message;
			}
		},

		/**
		 * Update Invoice
		 * @param {Object} estimateParticular estimateParticular Object
		 */
		async _updateInvoice(estimateParticular) {
			let invoiceData = {
				issue_date: estimateParticular['issue_date'],
				transfers_deadline: estimateParticular['expiry_date'],
				bank_name: estimateParticular['bank_name'],
				bank_branch: estimateParticular['bank_branch'],
				account_type: estimateParticular['account_type'],
				account_number: estimateParticular['account_number'],
				account_holder: estimateParticular['account_holder'],
				update_user: this.userId,
			};

			let response = await InvoiceService.update(
				this.estimateParticularId,
				invoiceData
			);

			if (response || response.status !== 200) {
				console.log('%c Update Invoice successfully', 'color: red');
			} else {
				throw response.message;
			}
		},

		/**
		 * Create New Invoice
		 * @param {Object} estimateParticular estimateParticular Object
		 */
		async _createNewInvoice(estimateParticular) {
			let invoiceData = {
				quote_id: this.estimateParticularId,
				issue_date: estimateParticular['issue_date'],
				transfers_deadline: estimateParticular['expiry_date'],
				bank_name: estimateParticular['bank_name'],
				bank_branch: estimateParticular['bank_branch'],
				account_type: estimateParticular['account_type'],
				account_number: estimateParticular['account_number'],
				account_holder: estimateParticular['account_holder'],
				update_user: this.userId,
				pdf_invoice_image_key: this.invoiceData.pdf_image_key,
				pdf_invoice_file_key: this.invoiceData.pdf_file_key,
				status: 'onSave',
			};

			let response = await InvoiceService.post({
				doc_content: invoiceData,
			});

			if (response || response.status !== 200) {
				console.log('%c Create Invoice successfully', 'color: red');
			} else {
				throw response.message;
			}
		},
	},
};
